export default __webpack_public_path__ + "static/media/Astral Handguards.0855dea7.jpg";